import { CheckOutAsset, EditAsset } from "../components/supplier/currentInventoryReport/data";
import request from "../util/SuperagentUtils";

const BUYER_BASE_URL = "/api/buyers";

export const getBuyerInventoryReport = (accountId: string) => {
  return request.get(`${BUYER_BASE_URL}/${accountId}/inventory-report`);
};

export const getBuyerOverageDailyReportByDate = (baseUrl: string, locationId: string, buyerAccountId: string, date: string) => {
  return request.get(`${baseUrl}/api/overage-daily-report-by-date/${locationId}/${buyerAccountId}/${date}`);
};

export const deleteInventoryActivity = (inventoryActivityId: string) => {
  return request.delete(`api/inventory-activity/${inventoryActivityId}`);
};

export const checkOutInventory = (asset: CheckOutAsset) => {
  return request.post('api/check-out-images').send(asset);
};

export const editInventory = (asset: EditAsset) => {
  return request.put('api/inventory').send(asset);
}